module.exports = __webpack_public_path__ + "img/zohoLogo.ca88a991.svg";